import * as React from 'react';

interface ToolbarRegionProps {
  className: string;
  children: any;
}

export class ToolbarRegion extends React.Component <ToolbarRegionProps> {
  constructor(props) {
    super(props);
  }
  public render() {
    const classes = [
      'toolbar-region',
      'pwa-toolbar__row',
      this.props.className
    ].filter(val => val).join(' ');

    return (
      <section className={classes}>
        {this.props.children}
      </section>
    );
  }
}
